/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Fact_1_LInputs */

const en_cp_fact_1_l = /** @type {(inputs: Cp_Fact_1_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`build night → 14-week sprint → challenge → next step`)
};

const id_cp_fact_1_l = /** @type {(inputs: Cp_Fact_1_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`build night → sprint 14 minggu → challenge → lanjutan`)
};

/**
* | output |
* | --- |
* | "build night → 14-week sprint → challenge → next step" |
*
* @param {Cp_Fact_1_LInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_fact_1_l = /** @type {((inputs?: Cp_Fact_1_LInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Fact_1_LInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_fact_1_l(inputs)
	return en_cp_fact_1_l(inputs)
});